import { render } from "./UserOrderModal.vue?vue&type=template&id=e23927cc&scoped=true"
import script from "./UserOrderModal.vue?vue&type=script&lang=js"
export * from "./UserOrderModal.vue?vue&type=script&lang=js"

import "./UserOrderModal.vue?vue&type=style&index=0&id=e23927cc&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e23927cc"]])

export default __exports__